export const AGREGAR_TEACHER = 'AGREGAR_TEACHER';
export const OBTENER_TEACHER = 'OBTENER_TEACHER';
export const LISTA_TEACHERS = 'LISTA_TEACHERS';
export const ERROR_TEACHER = 'ERROR_TEACHER';
export const MATCH_TEACHER = 'MATCH_TEACHER';

export const AGREGAR_STUDENT = 'AGREGAR_STUDENT';
export const OBTENER_STUDENT = 'OBTENER_STUDENT';
export const LISTA_STUDENTS = 'LISTA_STUDENTS';
export const ERROR_STUDENT = 'ERROR_STUDENT';
export const MATCH_STUDENT = 'MATCH_STUDENT';

export const MOSTRAR_ALERTA = 'MOSTRAR_ALERTA';
export const OCULTAR_ALERTA = 'OCULTAR_ALERTA';

export const REGISTRO_EXITOSO = 'REGISTRO_EXITOSO';
export const REGISTRO_ERROR = 'REGISTRO_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const LOGIN_EXITOSO = 'LOGIN_EXITOSO';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CERRAR_SESION = 'CERRAR_SESION';
export const RECUPERAR_USUARIO = 'RECUPERAR_USUARIO';
export const EDITAR_USUARIO = 'EDITAR_USUARIO';
export const REINICIAR_PASSWORD = 'REINICIAR_PASSWORD';

export const GUARDAR_CUESTIONARIO = 'GUARDAR_CUESTIONARIO';
export const CONSULTAR_CUESTIONARIO = 'CONSULTAR_CUESTIONARIO';
export const OBTENER_FORMULARIOS = 'OBTENER_FORMULARIOS';
export const ASIGNAR_FORMULARIO = 'ASIGNAR_FORMULARIO';
export const CONSULTAR_EVALUACION = 'CONSULTAR_EVALUACION';
export const GUARDAR_EVALUACION = 'GUARDAR_EVALUACION';
export const ACTIVAR_CUESTIONARIO = 'ACTIVAR_CUESTIONARIO';
export const OBTENER_EVALUACIONES = 'OBTENER_EVALUACIONES';
export const RECORRER_EVALUACIONES = 'RECORRER_EVALUACIONES';